









import VueOptions from '@utils/VueOptions'


settings =
  name: 'Timeline'
  vue:
    props: ['arc']

export default VueOptions.vue settings
